<template>
  <div class="mobile user-info">
    <div class="user-info-content">
      <div class="uid" v-if="!state.cpUserInfo.cpUserId || !state.cpUserInfo.mwrToken">
        {{ $t('payment.validateUser.desc') }}:
        <span class="btn" @click="openValidateUserIdDialog">
          [{{ $t('payment.userDialog.id') }}]
        </span>
      </div>
      <div class="uid" v-else>
        {{ $t('payment.validateUser.desc') }}: {{ state.cpUserInfo.cpUserId }}
        <span class="btn" @click="logout">
          [{{ $t('mwr.logout') }}]
        </span>
      </div>
      <div class="turn">
        {{ $t('mwr.turn') }}: {{ mwrData.shootDetail.totalShotCount - mwrData.shootDetail.usedShotCount }}
        <div class="bullet"></div>
      </div>
    </div>
    <!-- <ValidateUserDialog v-model="data.validateUserDialog.visible" /> -->
    <Dialog :modelValue="data.validateUserDialog.visible" @update:modelValue="updateValidateUserDialogVisible" type="validateUser" :showClose="false">
      <div class="dialog-content">
        <div class="form" v-if="(!state.cpUserInfo.cpUserId || !state.cpUserInfo.mwrToken) && !state.tempCpUserInfo.cpUserId">
          <div class="form-item">
            <div class="form-item-label user-id" @click="openUserGuide">
              <i class="icon-question"></i>
              {{ $t('payment.validateUser.desc') }}
            </div>
            <div class="form-item-input">
              <input :class="state.locale" :value="state.userId" @input="handleInput" type="text" :placeholder="$t('payment.validateUser.enterUserId')">
            </div>
            <div class="form-item-button">
              <MwrButton type="yellow" @click="handleActSubmit('mwr')">{{ $t('payment.validateUser.submit') }}</MwrButton>
            </div>
          </div>
        </div>
        <div class="confirm-box" v-else>
          <div class="info">
            <div class="info-item">
              <div class="info-item-label">
                {{ $t('payment.userDialog.id') }}: 
              </div>
              <div class="info-item-value">
                {{ state.tempCpUserInfo.cpUserId }}
              </div>
            </div>
            <div class="info-item">
              <div class="info-item-label">
                {{ $t('payment.userDialog.name') }}: 
              </div>
              <div class="info-item-value">
                {{ state.tempCpUserInfo.cpNickName }}
              </div>
            </div>
          </div>
          <div class="desc">
            {{ $t('payment.userDialog.confirmText') }}
          </div>
          <div class="btn-box">
            <MwrButton type="yellow" @click="handleLocaleConfirm">{{ $t('payment.userDialog.confirmInput') }}</MwrButton>
            <MwrButton type="blue" @click="handleLocaleCancel">{{ $t('payment.userDialog.cancelInput') }}</MwrButton>
          </div>
        </div>
      </div>
      
    </Dialog>
  </div>
</template>

<script setup>
/* eslint-disable no-unused-vars */
import { defineEmits, reactive, watch, computed, inject } from 'vue'
import useValidateUser from '@/components/ValidateUser/script'
import Dialog from '@/components/Dialog/ActMwr/index.vue'
import MwrButton from '../MwrButton/index.vue'
import { useStore } from 'vuex'
const mwrData = inject('mwrData')
const store = useStore()
// import ValidateUserDialog from '../Dialog/ValidateUserDialog/index.vue'
const emit = defineEmits(['resetUserInfo', 'getUserInfoSuccess'])
const data = reactive({
  turn: 10,
  cpUserInfo: computed(() => store.state.cpUserInfo),
  validateUserDialog: {
    visible: false,
  }
})

// watch(() => data.cpUserInfo, () => {
//   if (!data.cpUserInfo.cpUserId) {
//     data.validateUserDialog.visible = true
//   }
// }, { deep: true, immediate: true })
const { state, handleActSubmit, handleInput, handleConfirm, handleCancel, resetUserInfo, openUserGuide, closeImageViewer } = useValidateUser(emit, 'mwr')

const logout = () => {
  resetUserInfo()
  emit('resetUserInfo')
}
const openValidateUserIdDialog = () => {
  // data.validateUserDialog.visible = true
}

watch(() => data.cpUserInfo.cpUserId, (newVal) => {
  if (!newVal) {
    data.validateUserDialog.visible = true
  } else {
    data.validateUserDialog.visible = false
  }
}, { deep: true, immediate: true })

const handleLocaleConfirm = () => {
  handleConfirm()
  // data.validateUserDialog.visible = false
}
const handleLocaleCancel = () => {
  handleCancel()
  // data.validateUserDialog.visible = false
}

const updateValidateUserDialogVisible = (value) => {
  handleCancel()
  data.validateUserDialog.visible = value
}
</script>

<style scoped lang="less" src="./mobile_style.less"></style>